<template>
    <div v-html="'NotFound'"/>
</template>

<script>
export default { name: "NotFound" };
</script>